import { Link } from "@tanstack/react-router";
import { Users } from "lucide-react";
import { track } from "@/lib/track";

/**
 * Homepage therapist line — one sentence plus Learn More, pointing at the
 * therapist information on the Join Recovery Trauma™ page. No prices, no
 * support email on the homepage.
 */
export function TherapistOfferLine() {
  return (
    <div
      data-commerce
      className="mx-auto mt-4 flex max-w-xl flex-col items-center gap-2 rounded-2xl border border-gold/30 bg-card/70 px-4 py-3 text-center"
    >
      <p className="flex items-start gap-2 text-sm leading-relaxed text-foreground/85">
        <Users className="mt-0.5 h-4 w-4 shrink-0 text-[var(--gold-deep)]" strokeWidth={2} />
        Are you a therapist? Join Recovery Trauma™ and add up to 5 clients for FREE.
      </p>
      <Link
        to="/membership"
        hash="for-therapists"
        onClick={() => track("cta_click", { cta: "therapist_learn_more" }, { source: "home_therapist_line" })}
        className="inline-flex min-h-10 items-center rounded-full border border-gold/45 px-4 text-xs font-semibold uppercase tracking-[0.16em] text-[var(--gold-deep)] transition hover:-translate-y-0.5 hover:bg-[var(--gold-soft)]/40"
      >
        Learn more
      </Link>
    </div>
  );
}
